// Generated by CoffeeScript 1.12.7
(function() {
  var VASTNonLinear;

  VASTNonLinear = (function() {
    function VASTNonLinear() {
      this.id = null;
      this.width = 0;
      this.height = 0;
      this.expandedWidth = 0;
      this.expandedHeight = 0;
      this.scalable = true;
      this.maintainAspectRatio = true;
      this.minSuggestedDuration = 0;
      this.apiFramework = "static";
      this.type = null;
      this.staticResource = null;
      this.htmlResource = null;
      this.iframeResource = null;
      this.nonlinearClickThroughURLTemplate = null;
      this.nonlinearClickTrackingURLTemplates = [];
      this.adParameters = null;
    }

    return VASTNonLinear;

  })();

  module.exports = VASTNonLinear;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ../~/vast-client/dist/nonlinear.js
// module id = 27
// module chunks = 0